export interface InvoiceStatsData {
  totalInvoices: number;
  totalPaidInvoices: number;
  totalPendingInvoices: number;
  totalOverDueInvoices: number;
  totalCancelledInvoices: number;
  totalDraftInvoice: number;
  totalInvoiceValue: number;
  totalRefundedInvoices: number;
  dateRange: string;
}
export interface RecurringInvoiceStatsData {
  totalActiveReoccurring: number;
  totalPausedReoccurring: number;
  totalCancelledReoccurring: number;
  totalExpiredReoccurring: number;
  dateRange: string;
}
export type Filter =
  | { reoccurringStatus: string; isReoccurring: boolean | null }
  | { status: string; isReoccurring: boolean | null }
  | { billable: boolean | null; paymentMethod: string }
  | { stockStatus: string; variantStatus: string }
  | { status: string };

export type IRecurringInvoiceFilter =
  | { reoccurringStatus: string }
  | { billable: boolean | null; paymentMethod: string | null }
  | { stockStatus: string; variantStatus: string };

export type SalesStatus =
  | "pending"
  | "paid"
  | "due"
  | "draft"
  | "cancelled"
  | "refunded"
  | "Expired"
  | "Active"
  | "paused"
  | "Quote";

export type RecurringStatus = "cancelled" | "expired" | "active" | "paused";

export type IExpensePayment =
  | "card"
  | "cash"
  | "Bank Transfer"
  | "paystack"
  | "fluterwave";

export interface CompanyStatsData {
  totalInvoices: number;
  totalExpenses: number;
  totalCustomers: number;
  totalInventory: number;
  totalServices: number;
  dateRange: string;
}

export enum ServiceTypes {
  session_based = "session-based",
  time_based = "time-based",
}
